import { useQuery } from '@w/react-query'
import { Button } from '@w/ui/components/button'
import type { SpaceResource } from '../router/spaces-resources'
import { useNavigate, useRouterContext } from '../router/flashcards-fe.router-bindings'
import { pageRouteParams } from '../router/page-route-params'
import { spaceTreeOptions } from '../db/spaces-queries'
import { unreadableReason } from './item-readers'

/** One placeholder per tree row the read could not decode; the read records nothing. */
export function FailedPageItems({ resource }: { resource: SpaceResource }) {
  const ctx = useRouterContext()
  const navigate = useNavigate()
  const tree = useQuery(spaceTreeOptions(resource), resource.queryClient)
  const items = tree.error ? [] : tree.data?.unreadable ?? []
  return <>{items.map(item => <Button className="w-32 max-w-full whitespace-normal break-all" key={item.key} data-testid={`flashcards-page-failed-${item.key}`} onClick={() => {
    navigate({ to: '/$workspaceId/spaces/$spaceId/pages/$pageId', params: pageRouteParams(ctx, resource.space.id, item.key) })
  }}>{`${unreadableReason(item.unreadable)} · ${item.key}`}</Button>)}</>
}
